"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _glamor = require("glamor");

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _create = require("./redux/create");

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require("./ApiClient");

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _reactRouterScroll = require("react-router-scroll");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _user = require("redux/modules/user");

var userActions = _interopRequireWildcard(_user);

var _redial = require("redial");

var _reactRouterRedux = require("react-router-redux");

var _RedialTransitOnFetch = require("utils/RedialTransitOnFetch");

var _RedialTransitOnFetch2 = _interopRequireDefault(_RedialTransitOnFetch);

var _cosmosNavigation = require("./utils/cosmosNavigation");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _glamor.rehydrate)(window.__glam); /* global __DEVTOOLS__ */

var getRoutes = require("./pages/routes");

require("babel-polyfill");

console.log("Megascans v" + __VERSION__);

var client = (0, _ApiClient.apiClientFactory)();

var dest = document.getElementById("content");
var store = (0, _create2.default)(client, window.__data, _reactRouter.browserHistory);
var finalHistory = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

// Initialize cosmos flag BEFORE setting up navigation interceptor to avoid race conditions
(0, _cosmosNavigation.initializeCosmosFlag)().then(function () {
  // Intercept ALL client-side navigation when cosmos mode is enabled
  // This allows us to do full page loads without changing every browserHistory/router call
  _reactRouter.browserHistory.listen(function (location) {
    if ((0, _cosmosNavigation.getIsCosmosEnabled)()) {
      var fullUrl = location.pathname + (location.search || "");
      console.log("Cosmos mode: Intercepting navigation, doing full page load to:", fullUrl);
      window.location.href = fullUrl;
    }
  });

  // Setup router first
  setupRouter();

  // Then attempt to load auth if not loaded already
  // This happens after render so components can receive updates
  if (!store.getState().auth.loggedIn) {
    console.log("[client.jsx] Auth not loaded, loading now...");
    // Load auth token first
    var authLoadResult = store.dispatch(authActions.load());

    // Then load user data if auth was successful
    // This ensures SiteHeader gets both auth.loggedIn AND user.loaded
    _promise2.default.resolve(authLoadResult).then(function () {
      console.log("[client.jsx] Auth load completed, loggedIn:", store.getState().auth.loggedIn);
      if (store.getState().auth.loggedIn) {
        console.log("[client.jsx] Loading user data...");
        store.dispatch(userActions.load()).then(function () {
          console.log("[client.jsx] User load completed, loaded:", store.getState().user.loaded);
        });
      }
    });
  } else {
    console.log("[client.jsx] Auth already loaded");
  }
});

function setupRouter() {

  var shouldUpdateScroll = function shouldUpdateScroll(prevProps, _ref) {
    var state = _ref.location.state;

    var pathname = prevProps && prevProps.router && prevProps.router.location && prevProps.router.location.pathname;
    // Reset scroll for these pages
    if (pathname && (pathname.toLowerCase().startsWith("/purchase") || pathname.toLowerCase().startsWith("/subscribe"))) {
      return true;
    }

    var shouldUpdate = (!state || !state.modal) && (!prevProps || !prevProps.location.state || !prevProps.location.state.modal);
    return shouldUpdate;
  };

  (0, _reactRouter.match)({ history: finalHistory, routes: getRoutes(store) }, function (error, redirectLocation, renderProps) {
    var component = _react2.default.createElement(_reactRouter.Router, (0, _extends3.default)({}, renderProps, { render: (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll.useScroll)(shouldUpdateScroll)) }));

    _reactDom2.default.render(_react2.default.createElement(
      _reactRedux.Provider,
      { store: store, key: "provider" },
      component
    ), dest);
  });

  if (process.env.NODE_ENV !== "production") {
    window.React = _react2.default; // enable debugger
    /* window.Perf = require('react-addons-perf');*/

    if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes["data-react-checksum"]) {
      console.error("Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.");
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/client.jsx
// module id = 1482
// module chunks = 0